import React, { useRef, useState } from "react";
import { CircularProgress, MenuItem, Stack, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { updateReferralStatusFunc } from "../../actions/Referrals";
import { REFERRAL_STATUS_OPTIONS, referralStatusValue } from "./referralStatusOptions";

export default function ReferralStatusSelect({ id, status, referrerName, onFeedback }) {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const inFlight = useRef(false);
  const value = referralStatusValue(status);

  const handleChange = async (event) => {
    const nextStatus = event.target.value;
    if (inFlight.current || nextStatus === value) return;
    inFlight.current = true;
    setSaving(true);
    try {
      await dispatch(updateReferralStatusFunc(id, nextStatus));
      onFeedback({ severity: "success", message: "Referral status updated" });
    } catch (error) {
      onFeedback({ severity: "error", message: error.message });
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };

  return (
    <Stack direction="row" alignItems="center" gap={1} width="100%">
      <TextField
        select
        size="small"
        value={value}
        onChange={handleChange}
        disabled={saving}
        sx={{ width: "100%", maxWidth: 260 }}
        SelectProps={{
          displayEmpty: true,
          SelectDisplayProps: { "aria-label": `Status for ${referrerName || "referral"}` },
        }}
      >
        {!value && <MenuItem value="" disabled>Not set</MenuItem>}
        {REFERRAL_STATUS_OPTIONS.map(option => (
          <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
        ))}
      </TextField>
      {saving && <CircularProgress size={16} aria-label="Saving referral status" />}
    </Stack>
  );
}
